import { Col, DatePicker, Row } from 'antd'
import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from "react-select"
import { GetSuppliers } from '../../../../store/thunks/vendorStoreThunk'
import dayjs from 'dayjs'

const UploadLicense = ({ storeObject, setStoreObject, licenseError, setLicenseError }) => {
    const dispatch = useDispatch();
    const handleRemove = (id) => {
        const temp = storeObject.licenseRequest.filter(
            (obj, index) => index !== id
        );
        const tempError = licenseError.filter((obj, index) => index !== id);
        setLicenseError(tempError);
        setStoreObject({
            ...storeObject,
            licenseRequest: temp,
        });
    };

    const { data: domains } = useSelector(state => state?.allProductDomains);
    const { data: level2Data } = useSelector(state => state?.suppliers)

    return (
        <Row>
            <Col className="gutter-row" xs={24} lg={24}>
                <div className="d-flex">
                    <p className="font-weight-bolder font-size-lg mb-3 h5">
                        Upload License
                        {storeObject?.licenseDetails?.length < 1 && (
                            <span className="text-danger">*</span>
                        )}
                    </p>
                    <span
                        className=""
                        onClick={(e) => {
                            e.preventDefault();
                            const temp = [...storeObject.licenseRequest];
                            const tempError = [...licenseError];
                            tempError.push({
                                productCategoryId: "Category is Mandatory",
                            });
                            setLicenseError(tempError);
                            temp.push({
                                // files: [
                                //   // {
                                //   //   fileType: "IMAGE",
                                //   //   file: "",
                                //   // },
                                //   // {
                                //   //   fileType: "FILE",
                                //   //   file: "",
                                //   // },
                                // ],
                            });
                            setStoreObject({
                                ...storeObject,
                                licenseRequest: temp,
                            });
                        }}
                    >
                        <i className="bg-warning flaticon2-plus icon-md-1x icons ml-2 p-0 px-1 rounded text-white"></i>
                    </span>
                </div>
 <div className='repeat_di mt-7'>
                {storeObject?.licenseRequest?.map((license, index) => {
                    const setField = (field, value) => {
                        const temp = [...storeObject.licenseRequest];
                        temp[index][field] = value;
                        setStoreObject({ ...storeObject, licenseRequest: temp });
                    };

                    const setError = (field, error) => {
                        const temp = [...licenseError];
                        temp[index][field] = error;
                        setLicenseError(temp);
                    };

                    const categoryOptions = domains?.map((list) => ({
                        label: list?.name?.en,
                        value: list,
                    })) || [];

                    const subCategoryOptions = level2Data?.map((list) => ({
                        label: list.name,
                        value: list,
                        isDisabled:
                            !list?.isMultiLicenseUpload &&
                            (storeObject.licenseRequest.some((obj) => obj.supplierId === list.id) ||
                                storeObject.licenseDetails.some(
                                    (obj) => obj.supplierId === list.id &&
                                        ["APPROVED", "PENDING"].includes(obj.status)
                                )),
                    })) || [];

                    return (
                                         
                        <div className="custom_div" key={index}>
                            <div className="d-flex justify-content-between align-items-center mb-5">
                                <i className="ki ki-close upload_close" onClick={() => handleRemove(index)} />
                            </div>

                            <div className="row m-0">
                                {/* Category */}
                                <div className="col-sm-3">
                                    <label className="font-weight-bolder font-size-sm">
                                        Select Category <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Select
                                        isClearable
                                        className={licenseError[index]?.productCategoryId ? "invalid text-capitalize" : "text-capitalize"}
                                        options={categoryOptions}
                                        value={categoryOptions.find((item) => item.value.id === license.productCategoryId) || null}
                                        onChange={(val) => {
                                            setField("productCategoryId", val?.value?.id || "");
                                            setField("supplierId", "");
                                            setError("productCategoryId", val?.value?.id ? "" : "Category is Mandatory");
                                            setError("supplierId", val?.value?.isMandatoryToSelectSubCategories && !license?.supplierId ? "Sub Category is Mandatory" : "");
                                            setError("isMandatoryToSelectSubCategories", val?.value?.isMandatoryToSelectSubCategories);
                                            dispatch(GetSuppliers({ productDomain: val?.value?.id }))
                                        }}
                                    />
                                    <small className="text-danger">{licenseError[index]?.productCategoryId}</small>
                                </div>

                                {/* Sub Category */}
                                <div className="col-sm-3">
                                    <label className="font-weight-bolder font-size-sm">
                                        Select Sub Category{" "}
                                        {licenseError[index]?.isMandatoryToSelectSubCategories && <span style={{ color: "red" }}>*</span>}
                                    </label>
                                    <Select
                                        isClearable
                                        className={licenseError[index]?.supplierId ? "invalid text-capitalize" : "text-capitalize"}
                                        onFocus={() => dispatch(GetSuppliers({ productDomain: license?.productCategoryId }))}
                                        options={subCategoryOptions}
                                        value={license?.supplierId ? { label: license.supplierName, value: license.supplierId } : ""}
                                        onChange={(val) => {
                                            setField("supplierId", val?.value?.id || "");
                                            setField("supplierName", val?.value?.name || "");
                                            setError("supplierId", val?.value ? "" : licenseError[index].isMandatoryToSelectSubCategories ? "Sub Category is Mandatory" : "");
                                            const isMandatory = val?.value?.isLicenseMandatory;
                                            setError("licenseNumber", isMandatory && !license.licenseNumber ? "License Number is Mandatory" : "");
                                            setError("isMandatoryToUploadLicense", isMandatory);
                                            setError("licenseMedia", isMandatory && !license?.file?.file ? "File is Mandatory" : "");
                                            setError("expiryDate", isMandatory && !license?.expiryDate ? "Expiry Date is Mandatory" : "");
                                        }}
                                    />
                                    <small className="text-danger">{licenseError[index]?.supplierId}</small>
                                </div>

                                {/* License Number */}
                                <div className="col-sm-2">
                                    <label className="font-weight-bolder font-size-sm">
                                        {license?.licenseId === "licenses/316087432" ? "Seed certification number" : "License Number"}
                                        {licenseError[index]?.isMandatoryToUploadLicense && <span style={{ color: "red" }}>*</span>}
                                    </label>
                                    <input
                                        placeholder="Enter here"
                                        className={`form-control ${licenseError[index]?.licenseNumber ? "invalid" : ""}`}
                                        disabled={!license?.supplierId}
                                        value={license?.licenseNumber || ""}
                                        onChange={(e) => {
                                            const value = e.target.value.trim();
                                            setField("licenseNumber", value);
                                            const isMandatory = licenseError[index]?.isMandatoryToUploadLicense;
                                            setError("licenseNumber", value ? "" : isMandatory ? "License Number is Mandatory" : "");
                                            setError("licenseMedia", value && !license?.file?.file ? "File is Mandatory" : "");
                                            setError("expiryDate", value && !license?.expiryDate ? "Expiry Date is Mandatory" : "");
                                        }}
                                    />
                                    <small className="text-danger">{licenseError[index]?.licenseNumber}</small>
                                </div>

                                {/* Expiry Date */}
                                <div className="col-sm-2">
                                    <label className="font-weight-bolder font-size-sm">
                                        Expiry Date {licenseError[index]?.isMandatoryToUploadLicense && <span style={{ color: "red" }}>*</span>}
                                    </label>
                                    <DatePicker
                                        format={"YYYY-MM-DD"}
                                        className={licenseError[index]?.expiryDate ? "invalid" : ""}
                                        disabled={!license?.licenseNumber}
                                        style={{ width: "100%" }}
                                        disabledDate={(current) => current && current < moment().startOf("day")}
                                        value={license?.expiryDate ? dayjs(license?.expiryDate) : ""}
                                        onChange={(date) => {
                                            const formatted = date ? dayjs(date).format("YYYY-MM-DD") : "";
                                            setField("expiryDate", formatted);
                                            setError("expiryDate", formatted ? "" : licenseError[index]?.isMandatoryToUploadLicense ? "Expiry Date is Mandatory" : "");
                                        }}
                                    />
                                    <small className="text-danger">{licenseError[index]?.expiryDate}</small>
                                </div>

                                {/* Upload File */}
                                <div className="col-sm-2">
                                    <label className="font-weight-bolder font-size-sm">
                                        Upload File {licenseError[index]?.isMandatoryToUploadLicense && <span style={{ color: "red" }}>*</span>}
                                    </label>
                                    <input
                                        type="file"
                                        accept=".pdf,.xls,.doc,.docx,.jpg,.jpeg,.png,.svg,.ogg"
                                        className={`form-control p-2 ${licenseError[index]?.licenseMedia ? "invalid" : ""}`}
                                        disabled={!license?.licenseNumber}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            setField("file", file ? { fileType: "FILE", file } : {});
                                            setError("licenseMedia", file ? "" : licenseError[index]?.isMandatoryToUploadLicense ? "File is Mandatory" : "");
                                        }}
                                    />
                                    <small className="text-danger">{licenseError[index]?.licenseMedia}</small>
                                </div>
                            </div>
                        </div>
                    
                


                );
                })}



</div>


            </Col>
        </Row>
    )
}

export default UploadLicense